import React from 'react'
import { URL_FACEBOOK, URL_SOUNDCLOUD, URL_TWITTER } from '../../constants'

function Social() {

  return (
    <div>
      <span className="content-title">Nous suivre sur les réseaux sociaux</span>

      <div className="card-panel">

      <p className="justify">
        Vous pouvez nous retrouver sur les réseaux sociaux <b>Facebook</b>, <b>Twitter</b>, <b>Google+</b> et <b>Soundcloud</b> :
      </p>

      <div className="row center">


        <div className="col s12 m6 l4"><a
          className="grey-text text-lighten-3 waves-effect waves-light btn facebook-button"
          href={ URL_FACEBOOK } target="_blank" rel="noopener"><i className="material-icons left">thumb_up</i>Facebook</a><br/>&nbsp;
        </div>
        <div className="col s12 m6 l4"><a
          className="grey-text text-lighten-3 waves-effect waves-light btn twitter-button"
          href={ URL_TWITTER } target="_blank" rel="noopener"><i
          className="material-icons left">repeat</i>Twitter</a><br/>&nbsp;
        </div>
        <div className="col s12 m6 l4"><a
          className="grey-text text-lighten-3 waves-effect waves-light btn soundcloud-button"
          href={ URL_SOUNDCLOUD } target="_blank" rel="noopener"><i
          className="material-icons left">cloud</i>Soundcloud</a><br/>&nbsp;
        </div>

      </div>

      <p className="justify">
        N'hésitez par à <b>Liker</b> et à <b>Partager</b> !
      </p>

    </div>
    </div>
  );

}

export default Social;



/** WEBPACK FOOTER **
 ** ./src/components/Contact/Social.js
 **/